/*USER LIST*/
Vue.component('division_manager', {
    template:'#divisionmanager-template',

    data:function(){
        return{
            list: [],
            searchString:'',
            users: [],
            modal:'',
            editing_row_id: null,
            editing_row: {},
            editing_row_original_content: {}
        };
    },
    watch: {
        editing_row: function() {

        }
    },
    created:function(){
        activeInstance = this;

        vex.defaultOptions.className="vex-theme-flat-attack";

        showLoadingOverlay();
        axios.get(baseURL+'/api/users/active').then(function (response) {
            $('body').LoadingOverlay("hide");
            activeInstance.users = response.data;
        }).catch(function (error) {
            console.log(error);
            $('body').LoadingOverlay("hide");
        });

        activeInstance.getDivisions();

    },
    methods:{
        getDivisions:function(){
            axios.get(baseURL+'/api/divisions/list')
                .then(function(response){
                $('body').LoadingOverlay("hide");

                    activeInstance.list = response.data;
                    setTimeout(function(){
                        var $table = $('.fixed_header_table');
                        $table.floatThead({
                            top:70
                        });
                    },200);

                 })
                .catch(function(error){

                });
        },
        filterFallbackUser: function(arr, division) {
            var filtered = arr.filter(function(elem) {
                return elem.id != division.supervisor_user_id;
            });

            return filtered;
        },
        create: function() {

            var users = '';

            for(var i = 0, i_ = this.users.length; i < i_; i ++) {
                users += '<option value="'+this.users[i].id+'">'+this.users[i].name+'</option>';
            }

            var new_division_popup = bootbox.dialog({
                title: 'Új divízió létrehozása',
                message: '<div class="row"><div class="col-sm-12"><input id="new_division_name" autofocus placeholder="Divízió neve" class="form-control" type="text"></div></div>\
                            <div class="row" style="margin-otp: 20px"><div class="col-sm-6"><label><div style="margin-bottom: 10px;margin-top:20px">Jóváhagyó:</div><select class="form-control" id="new_supervisor_user_id">'+users+'</select></label></div>\
                            <div class="col-sm-6"><label><div style="margin-bottom: 10px;margin-top:20px">Helyettesítő jóváhagyó:</div><select class="form-control" id="new_fallback_supervisor_user_id"><option value="null" selected>Nincs</option>'+users+'</select></label></div></div>\
                            ',
                buttons: {
                    ok: {
                        label: "Mentés",
                        className: 'btn-success',
                        callback: function() {
                            axios.post(baseURL + '/admin/division/create',
                            {
                                name: new_division_name.value,
                                supervisor_user_id: new_supervisor_user_id.value,
                                fallback_supervisor_user_id: new_fallback_supervisor_user_id.value
                            }).then(function(response) {
                                //activeInstance.list.push(response.data);
                                successNotification('A divízió mentve.');
                                activeInstance.getDivisions();
                            }).catch(function(error) {
                                console.log(error);
                            });
                        }
                    },
                    cancel: {
                        label: "Mégse",
                        className: 'btn-danger',
                        callback: function() {
                            
                        }
                    }
                }
            });
        },
        save: function() {
            bootbox.confirm("Biztosan menteni szeretnéd a változásokat?", function(result) {
                if (result) {
                    axios.post(baseURL + '/admin/division/update',
                    {
                        id: activeInstance.editing_row.id,
                        name: activeInstance.editing_row.name,
                        supervisor_user_id: activeInstance.editing_row.supervisor_user_id,
                        fallback_supervisor_user_id: activeInstance.editing_row.fallback_supervisor_user_id,
                        enabled: activeInstance.editing_row.enabled,
                        production: activeInstance.editing_row.production,
                        titles: activeInstance.editing_row.titles,

                    }).then(function(response) {
                        if (response.data.users_in_division) {
                            console.log(response.data.users_in_division);

                            var users = '';

                            for(var i = 0, i_ = response.data.users_in_division.length; i < i_; i ++) {
                                users += '<a target="_blank" href="'+baseURL+'/admin/user/edit/'+response.data.users_in_division[i].id+'">'+response.data.users_in_division[i].firstname+' '+response.data.users_in_division[i].lastname+'</a><br/>';
                            }

                            var divisions = '';



                            $.each(activeInstance.list,function(division_index,division){
                                if(activeInstance.editing_row.id != division.id){
                                    divisions+='<option value="'+division.id+'">'+division.name+'</option>';
                                }

                            });

                            var dialog = bootbox.dialog({
                                title: 'A(z) '+activeInstance.editing_row.name+' divízióhoz személyek vannak hozzárendelve.',
                                message: '<p>Deaktiválás előtt át kell a tagokat mozgatni egy másik divízióba.</p>' +
                                    '<p> A divízió jelenlegi tagjai: <br> '+users+'</p>'
                            });

                            activeInstance.cancel();
                            return;
                        }

                        activeInstance.editing_row_id = null;
                        successNotification('A divízió mentve.');
                    }).catch(function(error) {
                        console.log(error);
                    });
                }
            });
        },
        moveDivisionMembersToAnotherDivision:function(){



        },
        cancel: function() {

            this.editing_row.name = this.editing_row_original_content.name;
            this.editing_row.supervisor_user_id = this.editing_row_original_content.supervisor_user_id;
            this.editing_row.fallback_supervisor_user_id = this.editing_row_original_content.fallback_supervisor_user_id;
            this.editing_row.enabled = this.editing_row_original_content.enabled;
            this.editing_row.production = this.editing_row_original_content.production;
            this.editing_row.titles = this.editing_row_original_content.titles;

            this.editing_row_id = null;
        },
        edit: function(division, event) {

            this.editing_row_id = division.id;
            this.editing_row = division;

            this.editing_row_original_content = JSON.parse(JSON.stringify(division));
        },
        addDivisionTitle: function(division) {
            vex.dialog.prompt({
                message: 'Munkakör neve',
                callback: function (value) {
                    if (value.length) {
                        for (var i = 0, i_ = division.titles.length; i < i_; i ++) {
                            if (value.toLowerCase() == division.titles[i].name.toLowerCase()) {
                                vex.dialog.alert({
                                    message: "A(z) "+division.name+" divízióban már szerepel a(z) "+value+" munkakör."
                                });
                                return;
                            }
                        }

                        division.titles.push({
                            name: value,
                            machine_name: activeInstance.$root.urlFriendly(value)
                        });
                    }
                }
            });
        },
        removeTitle(division, title, index) {
            vex.dialog.confirm({
                message: 'Biztosan törölni szeretnéd a '+title.name+' munkakört?',
                callback: function (value) {
                    if (value) {
                        $.each(division.titles, function(i, item) {
                            if (item.machine_name == title.machine_name) {
                                division.titles.splice(i,1);
                                return false;
                            }
                        });
                    }
                }
            });
        },
        deleteDivision:function(division){

            vex.dialog.confirm({
                message: 'Biztosan törölni szeretnéd a(z) '+division.name+' divíziót?',
                callback: function (value) {
                    if (value) {
                        axios.post('/api/division/delete',{
                            division_id:division.id
                        })
                            .then(function(){
                                activeInstance.getDivisions();
                                return true;
                            })
                            .catch(function(){
                            });
                    }
                }
            });

        },
    }
});